//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {appBaseUrl} from "../../utils/commons";
import manualSearch from '@/components/manual-search';
export default {
  name: "order",
  components:{manualSearch},
  data() {
    return {
      orderTypeList: [],
      purorgList: [],
      orderType:'',
      wrapperHeight: 0,
      allLoaded: false,
      orderStateList: [
        {name:'全部',code:null},
        {name:'待确认',code:'1'},
        {name:'已确认',code:'2'},
        {name:'已作废',code:'6'},
        {name:'已退回',code:'7'}
        ],
      orderList: [],
      rulesObj:{
        search:'',
        orderType:'',
        purOrg:'',
        itemStatus:''
      },
      pageRules:{
        direction: "DESC",
        fromClientType: "h5",
        number: 0,
        property: "id",
        size:10,
        rules:[],
        specialConditions: [],
        workflowSearchBean:{},
        ignoreField: true
      }
    }
  },
  methods: {
    clear(){
      delete this.rulesObj.search;
      this.getOrderList()
    },
    getRules(e){
      if(e.length){
        e.forEach(val=>{
          this.rulesObj[val.ch]='';
          if(val.ch === 'date'){
            this.rulesObj[val.ch]={field: val.name,option:val.option,values:val.code}
          }else{
            this.rulesObj[val.ch]={field: val.name,option:val.option,values:[val.code]}
          }
        });
      }else{
        //重置菜单
        this.rulesObj={
          search:this.rulesObj.search
        }
      }
      this.getOrderList();
    },
    onCheckerClick(e){
      if(e){
        this.rulesObj.itemStatus={field: "status",option:'IN',values:[e]}
      }else{
        delete this.rulesObj.itemStatus
      }
      this.getOrderList();
    },
    goFlow(order){
      if(order.status !== '0' && order.status !== '6'){
        if(this.$store.state.device === 'wap'){
          let title = order.purOrder.supplierName;
          let orderNo = order.purOrder.orderTypeName + " | " + order.orderNo
          this.$router.push('/workflow/'+order.purOrder.requestId+'?component=ViewOrderDetailComponent&orderNo='+orderNo +"&title="+title);
        }else{
          document.location = "http://action:10061/?url=" + appBaseUrl + "workflow/" + order.purOrder.requestId + "?device=" + this.$store.state.device + '&&hiddentitle=1 && component=ViewOrderDetailComponent';
        }
      }else {
        this.$router.push('/purchase-order-view/'+order.purOrder.id);
      }
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      if(this.$store.state.device === 'wap'){
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top -50;
      }else{
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top ;
      }

    },
    //点击搜索按钮
    searchOrder(searchData){
      this.rulesObj.search = {field: "matName-matCode-purOrder.orderNo",collectIndex:-1,option: "LIKE_ANYWHERE",values:[searchData['key']]};
      this.getOrderList();
    },
    getOrderTypeList(){
      this.$loadingShow();
      this.$get('api/order-type/all').then((data) => {
        this.$loadingHide();
        this.orderTypeList = data;
        this.orderTypeList.unshift({name:'全部',code:''});
      }).catch(()=>{
        this.$loadingHide()
      })
    },
    orderTypeOnChange(e) {
      if(e){
        this.rulesObj.orderType={field:"purOrder.orderType.id",option:"IN",values:[e.id]}
      }else{
       delete this.rulesObj.orderType
      }
      this.getOrderList();
    },
    purorgOnChange(e) {
      if (e) {
        this.rulesObj.purOrg={field: "purOrder.purorg.purorgName-purOrder.purorg.purorgCode",option: "LIKE_ANYWHERE",values:[e.code]}
      } else {
        delete this.rulesObj.purOrg
      }
      this.getOrderList();
    },
    loadTop() {
      this.pageRules.number = 0 ;
      this.$post('/api/purOrderDetail/page',this.pageRules).then((list) => {
        this.orderList = list.content;
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.pageRules.number++;
      this.$post('/api/purOrderDetail/page',this.pageRules).then((list) => {
        this.orderList = this.orderList.concat(list.content);
        if(list.length<10){
          this.$vux.toast.text('已经加载全部');
        }
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onBottomLoaded();
      });
    },
    //获取全部采购组织列表
    getPurorgList() {
      this.$loadingShow();
      this.$get('api/purorg').then((data) => {
        data.forEach(val=>{
          val.name=val.purorgName;
          val.code=val.purorgCode
        });
        this.purorgList = data.filter(item =>{
          return item.enabled;
        });
        this.purorgList.unshift({code: '', name: '全部'})
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //获取全部订单
    getOrderList(){
      this.$loadingShow();
      this.pageRules.number = 0;
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field && val.values[0])
      this.$post('/api/purOrderDetail/page',this.pageRules).then((list) => {
        this.orderList = list.content;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    }
  },
  mounted() {
    this.init();
    this.getPurorgList();
    this.getOrderTypeList();
    this.$loadingShow();
    this.$get('api/person/current').then((res) => {
      this.$loadingHide();
      if(res.userType === '1'){
        this.getOrderList();
      }else{
        this.orderStateList = [
          {name:'全部',code:null},
          {name:'待确认',code:'1'},
          {name:'已确认',code:'2'}
        ];
        this.rulesObj.itemStatus = {
          field: "status",
          option: "IN",
          values: ["1","2"]
        };
        this.getOrderList();
      }
    }).catch(() => {
      this.$loadingHide();
    });
  }
}




// WEBPACK FOOTER //
// ./src/page/home/order.vue